export default __webpack_public_path__ + "static/media/Agentes_on.208a0eca.svg";